module.exports = __webpack_public_path__ + "static/media/SIT_logo.e19e7711.png";